import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { IBestfitOverviewApplication } from '../bestfit-overview.interface';
import { EventType } from '../enums';

export class BestfitOverviewReadyEvent implements IEvent {
	public static EventType = EventType.BESTFIT_OVERVIEW_READY;

	public readonly timestamp: Date;
	public readonly eventType = BestfitOverviewReadyEvent.EventType;

	constructor(public bestfitOverviewApplication: IBestfitOverviewApplication) {
		this.timestamp = new Date();
	}
}
